import api from './api';
import {
  Abwesenheit,
  AbwesenheitAntragRequest,
  AbwesenheitAnlegenRequest,
  AbwesenheitStatus,
  AbwesenheitKonflikt,
  UrlaubSaldo,
  UrlaubsanspruchRequest,
} from '../types';

export const abwesenheitService = {
  // Mitarbeiter
  antrag: async (data: AbwesenheitAntragRequest): Promise<Abwesenheit> =>
    (await api.post('/abwesenheiten', data)).data,

  meine: async (): Promise<Abwesenheit[]> =>
    (await api.get('/abwesenheiten/meine')).data,

  stornieren: async (id: number): Promise<Abwesenheit> =>
    (await api.put(`/abwesenheiten/${id}/stornieren`)).data,

  meinSaldo: async (jahr?: number): Promise<UrlaubSaldo> =>
    (await api.get('/urlaub/saldo', { params: jahr ? { jahr } : {} })).data,

  // Admin
  alle: async (userId?: number, status?: AbwesenheitStatus): Promise<Abwesenheit[]> =>
    (await api.get('/abwesenheiten', { params: { ...(userId ? { userId } : {}), ...(status ? { status } : {}) } })).data,

  genehmigen: async (id: number): Promise<Abwesenheit> =>
    (await api.put(`/abwesenheiten/${id}/genehmigen`)).data,

  ablehnen: async (id: number, ablehnungsGrund: string): Promise<Abwesenheit> =>
    (await api.put(`/abwesenheiten/${id}/ablehnen`, { ablehnungsGrund })).data,

  anlegen: async (data: AbwesenheitAnlegenRequest): Promise<Abwesenheit> =>
    (await api.post('/abwesenheiten/anlegen', data)).data,

  konflikte: async (id: number): Promise<AbwesenheitKonflikt[]> =>
    (await api.get(`/abwesenheiten/${id}/konflikte`)).data,

  saldoFuerUser: async (userId: number, jahr?: number): Promise<UrlaubSaldo> =>
    (await api.get(`/urlaub/saldo/${userId}`, { params: jahr ? { jahr } : {} })).data,

  setAnspruch: async (userId: number, data: UrlaubsanspruchRequest): Promise<void> => {
    await api.put(`/urlaubsanspruch/${userId}`, data);
  },
};

export default abwesenheitService;
